import get from "lodash.get";
import { BusinessUnitConfig } from "../../../../core/types";

type BUHasReviewFormEnabled = (businessUnitConfig: BusinessUnitConfig) => boolean;
export const buHasReviewFormEnabled: BUHasReviewFormEnabled = config =>
  get(config, "reviews.productReviewForm");
